export const blockIconsAudioandvideoReplayNew = (
	<span className='material-symbols-outlined'>replay</span>
);
